import React, {
  ChangeEvent,
  useState,
  ComponentType,
} from 'react';
import { Session } from '../../types/Session';
import api from '../../services/api';
import { auth } from '../../services/auth';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert/Alert';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';

interface Props {
  //onLogin: (session: Session) => void;
  //forgotPassword: (value: boolean) => void;
}

type Credentials = { name: string; password: string };

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://stagemporium.com/">
        stagemporium.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export const LoginPage: ComponentType<Props> = (
  {
    // onLogin,
    //forgotPassword,
  }
) => {
  const [name, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (): Promise<void> => {
    if (!name) {
      setError('Please enter your email');
    } else if (!password) {
      setError('Please enter your password');
    } else {
      setLoading(true);
      try {
        const sessionData = await api.post<Credentials, Session>(
          `/sessions`,
          { name, password },
          true
        );
        auth.setToken(sessionData.id);
        navigate('/');
        window.location.reload();
      } catch (error) {
        console.error(error);
        setError('Invalid credentials');
      }
      setLoading(false);
    }
  };
  const defaultTheme = createTheme();

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          background: '#fff',
          height: {
            xs: '100vh',
            md: 'auto',
          },
          borderRadius: {
            md: '15px',
          },
          boxShadow: {
            md: '0px 2px 15px -9px #0000006b',
          },
          mt: {
            md: '100px',
          },
          py: '50px',
        }}
      >
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar
            sx={{ m: 1, bgcolor: 'secondary.main' }}
            src={
              'https://www.stagemporium.com/wp-content/themes/stagsemporium/images/logo.png'
            }
          >
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{
                width: '100%',
                mt: '10px',
              }}
            >
              {error}
            </Alert>
          )}

          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              name="name"
              onChange={({
                target: { value },
              }: ChangeEvent<HTMLInputElement>) => setUsername(value)}
            />

            <TextField
              label="Password"
              fullWidth={true}
              variant="outlined"
              disabled={loading}
              onChange={({
                target: { value },
              }: ChangeEvent<HTMLInputElement>) => setPassword(value)}
              margin="normal"
              name="password"
              type="password"
            />

            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Sign In
            </Button>

            <Grid container>
              <Grid item xs>
                {/*  <Link href="#" variant="body2">
                  Forgot password?
                </Link>*/}
              </Grid>
              <Grid item>
                <Link href="/forgot-password" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 6 }} />
      </Container>
    </ThemeProvider>
  );
};
